import set from 'lodash/set';
import {createStore} from 'vuex'
import * as vuefront from '~/core/store/common/vuefront/vuefront.ts'
import * as position from '~/core/store/common/position/position.ts'
import * as apollo from '~/core/store/common/apollo/apollo.ts'
import * as apiHandler from '~/core/store/common/api-handler/api-handler.ts'
import * as notification from '~/core/store/common/notification/notification.ts'
import * as MenuModulesBlog from '~/core/store/menu/blog/blog.ts'
import * as MenuModulesStore from '~/core/store/menu/store/store.ts'
import * as MenuModulesPage from '~/core/store/menu/page/page.ts'
import * as BlogModulesCategory from '~/core/store/blog/category/category.ts'
import * as BlogModulesPost from '~/core/store/blog/post/post.ts'
import * as CommonModulesCountry from '~/core/store/common/country/country.ts'
import * as CommonModulesBreadcrumbs from '~/core/store/common/breadcrumbs/breadcrumbs.ts'
import * as CommonModulesZone from '~/core/store/common/zone/zone.ts'
import * as CommonModulesPage from '~/core/store/common/page/page.ts'
import * as CommonModulesHome from '~/core/store/common/home/home.ts'
import * as CommonModulesMenu from '~/core/store/common/menu/menu.ts'
import * as CommonModulesContact from '~/core/store/common/contact/contact.ts'
import * as CommonModulesCustomer from '~/core/store/common/customer/customer.ts'
import * as CommonModulesAddress from '~/core/store/common/address/address.ts'
import * as CommonModulesLanguage from '~/core/store/common/language/language.ts'
import * as CommonModulesKlaviyo from '~/core/store/common/klaviyo/klaviyo.ts'
import * as StoreModulesCart from '~/core/store/store/cart/cart.ts'
import * as StoreModulesWishlist from '~/core/store/store/wishlist/wishlist.ts'
import * as StoreModulesOrder from '~/core/store/store/order/order.ts'
import * as StoreModulesCurrency from '~/core/store/store/currency/currency.ts'
import * as StoreModulesCategory from '~/core/store/store/category/category.ts'
import * as StoreModulesManufacturer from '~/core/store/store/manufacturer/manufacturer.ts'
import * as StoreModulesProduct from '~/core/store/store/product/product.ts'
import * as StoreModulesCheckoutModulesPaymentaddress from '~/../checkout-app/lib/store/store/checkout/paymentAddress/paymentAddress.mjs'
import * as StoreModulesCheckoutModulesShippingaddress from '~/../checkout-app/lib/store/store/checkout/shippingAddress/shippingAddress.mjs'
import * as StoreModulesCheckoutModulesOrder from '~/../checkout-app/lib/store/store/checkout/order/order.mjs'
export default (ctx, inject) => {
  let modules = {}
  
  modules = set(modules, "vuefront", { namespaced: true, ...vuefront})
  modules = set(modules, "position", { namespaced: true, ...position})
  modules = set(modules, "apollo", { namespaced: true, ...apollo})
  modules = set(modules, "apiHandler", { namespaced: true, ...apiHandler})
  modules = set(modules, "notification", { namespaced: true, ...notification})
    modules = set(modules, ["menu"], { namespaced: true})
  modules = set(modules, ["menu","modules","blog"], { namespaced: true, ...MenuModulesBlog})
  modules = set(modules, ["menu","modules","store"], { namespaced: true, ...MenuModulesStore})
  modules = set(modules, ["menu","modules","page"], { namespaced: true, ...MenuModulesPage})
    modules = set(modules, ["blog"], { namespaced: true})
  modules = set(modules, ["blog","modules","category"], { namespaced: true, ...BlogModulesCategory})
  modules = set(modules, ["blog","modules","post"], { namespaced: true, ...BlogModulesPost})
    modules = set(modules, ["common"], { namespaced: true})
  modules = set(modules, ["common","modules","country"], { namespaced: true, ...CommonModulesCountry})
  modules = set(modules, ["common","modules","breadcrumbs"], { namespaced: true, ...CommonModulesBreadcrumbs})
  modules = set(modules, ["common","modules","zone"], { namespaced: true, ...CommonModulesZone})
  modules = set(modules, ["common","modules","page"], { namespaced: true, ...CommonModulesPage})
  modules = set(modules, ["common","modules","home"], { namespaced: true, ...CommonModulesHome})
  modules = set(modules, ["common","modules","menu"], { namespaced: true, ...CommonModulesMenu})
  modules = set(modules, ["common","modules","contact"], { namespaced: true, ...CommonModulesContact})
  modules = set(modules, ["common","modules","customer"], { namespaced: true, ...CommonModulesCustomer})
  modules = set(modules, ["common","modules","address"], { namespaced: true, ...CommonModulesAddress})
  modules = set(modules, ["common","modules","language"], { namespaced: true, ...CommonModulesLanguage})
  modules = set(modules, ["common","modules","klaviyo"], { namespaced: true, ...CommonModulesKlaviyo})
    modules = set(modules, ["store"], { namespaced: true})
  modules = set(modules, ["store","modules","cart"], { namespaced: true, ...StoreModulesCart})
  modules = set(modules, ["store","modules","wishlist"], { namespaced: true, ...StoreModulesWishlist})
  modules = set(modules, ["store","modules","order"], { namespaced: true, ...StoreModulesOrder})
  modules = set(modules, ["store","modules","currency"], { namespaced: true, ...StoreModulesCurrency})
  modules = set(modules, ["store","modules","category"], { namespaced: true, ...StoreModulesCategory})
  modules = set(modules, ["store","modules","manufacturer"], { namespaced: true, ...StoreModulesManufacturer})
  modules = set(modules, ["store","modules","product"], { namespaced: true, ...StoreModulesProduct})
    modules = set(modules, ["store","modules","checkout"], { namespaced: true})
  modules = set(modules, ["store","modules","checkout","modules","paymentAddress"], { namespaced: true, ...StoreModulesCheckoutModulesPaymentaddress})
  modules = set(modules, ["store","modules","checkout","modules","shippingAddress"], { namespaced: true, ...StoreModulesCheckoutModulesShippingaddress})
  modules = set(modules, ["store","modules","checkout","modules","order"], { namespaced: true, ...StoreModulesCheckoutModulesOrder})
  // Vuex registers every app with the global Vue Devtools hook when devtools
  // are enabled. An SSR app is created per request, so enabling that hook on
  // the server retains every completed request graph during local/test crawls.
  // Keep devtools available in the browser development build only.
  return createStore({
    modules,
    devtools: !import.meta.env.SSR && import.meta.env.DEV,
  })
}
